module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALSO BY "), _c('br'), _vm._v("ELENA FERRANTE")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781933372006/the-days-of-abandonment",
      "target": "_blank"
    }
  }, [_vm._v("The Days of Abandonment")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781933372167/troubling-love",
      "target": "_blank"
    }
  }, [_vm._v("Troubling Love")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Y ")]), _vm._v("B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RILLIANT ")]), _vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIEND")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("(")]), _vm._v("The Neapolitan Quartet"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781609450786/my-brilliant-friend",
      "target": "_blank"
    }
  }, [_vm._v("My Brilliant Friend")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781609451349/the-story-of-a-new-name",
      "target": "_blank"
    }
  }, [_vm._v("The Story of a New Name")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781609452339/those-who-leave-and-those-who-stay",
      "target": "_blank"
    }
  }, [_vm._v("Those Who Leave and Those Who Stay")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781609452865/the-story-of-the-lost-child",
      "target": "_blank"
    }
  }, [_vm._v("The Story of the Lost Child")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781609453701/the-beach-at-night",
      "target": "_blank"
    }
  }, [_vm._v("The Beach at Night")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781609452926/frantumaglia",
      "target": "_blank"
    }
  }, [_vm._v("Frantumaglia: A Writer's Journey")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781609455583/incidental-inventions",
      "target": "_blank"
    }
  }, [_vm._v("Incidental Inventions")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f0d5b8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/also.vue
// module id = 60
// module chunks = 0